import { combineReducers } from "redux";
import CreateDataReducer from "./CreateTicketReducer";
import TicketsReducer from "./TicketsReducer";
export default combineReducers({
    CreateDataReducer,
    TicketsReducer,
});
